/* tslint:disable */
/* eslint-disable */
/**
 * Payment API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/* tslint:disable */
/* eslint-disable */

/**
* このファイルは自動生成されています。そのためgit管理には含まれません。手動で編集してもdeploy時反映されません。
*/

/**
 * キャンセル料支払方法
 * @export
 * @enum {number}
 */
export enum PaymentMethodEnum {
    /** 車内決済 */
    IN_CAR_PAYMENT = '0',
    /** ネット決済 */
    APP_PAYMENT_CREDIT_CARD = '1',
    /** どちらでもよい */
    EITHER = '2',
    /** ApplePay */
    APP_PAYMENT_APPLE_PAY = '3',
    /** RingoPass */
    RINGO_PASS_PAYMENT = '4',
    /** 汎用QR */
    BACK_SEAT_PAYMENT = '5',
    /** CABPay */
    APP_PAYMENT_CAB_CARD = '6',
    /** 売掛払い */
    APP_PAYMENT_S_RIDE_BIZ = '7',
    /** PayPay */
    APP_PAY_PAY = '10',
    /** auPay */
    APP_AU_PAY = '11',
    /** d払い */
    APP_D_PAY = '12',
    /** 楽天Pay */
    APP_R_PAY = '13',
    /** アプリ決済（DiDi） */
    DIDI = '14',
    /** アプリ決済（Uber） */
    UBER = '15'
}

/**
 * キャンセル料支払方法 の Union 型
 * @export
 * @typedef PaymentMethod
 */
export type PaymentMethod =
  typeof PaymentMethodEnum[keyof typeof PaymentMethodEnum];

/**
 * キャンセル料支払方法 のラベルマップ
 * @export
 */
export const PaymentMethodLabels = {
    /**
     * 数値キー: PaymentMethodEnum.IN_CAR_PAYMENT
     * 名前キー:  IN_CAR_PAYMENT
     */
    [PaymentMethodEnum.IN_CAR_PAYMENT]: '車内決済',
    IN_CAR_PAYMENT:                             '車内決済',
    /**
     * 数値キー: PaymentMethodEnum.APP_PAYMENT_CREDIT_CARD
     * 名前キー:  APP_PAYMENT_CREDIT_CARD
     */
    [PaymentMethodEnum.APP_PAYMENT_CREDIT_CARD]: 'ネット決済',
    APP_PAYMENT_CREDIT_CARD:                             'ネット決済',
    /**
     * 数値キー: PaymentMethodEnum.EITHER
     * 名前キー:  EITHER
     */
    [PaymentMethodEnum.EITHER]: 'どちらでもよい',
    EITHER:                             'どちらでもよい',
    /**
     * 数値キー: PaymentMethodEnum.APP_PAYMENT_APPLE_PAY
     * 名前キー:  APP_PAYMENT_APPLE_PAY
     */
    [PaymentMethodEnum.APP_PAYMENT_APPLE_PAY]: 'ApplePay',
    APP_PAYMENT_APPLE_PAY:                             'ApplePay',
    /**
     * 数値キー: PaymentMethodEnum.RINGO_PASS_PAYMENT
     * 名前キー:  RINGO_PASS_PAYMENT
     */
    [PaymentMethodEnum.RINGO_PASS_PAYMENT]: 'RingoPass',
    RINGO_PASS_PAYMENT:                             'RingoPass',
    /**
     * 数値キー: PaymentMethodEnum.BACK_SEAT_PAYMENT
     * 名前キー:  BACK_SEAT_PAYMENT
     */
    [PaymentMethodEnum.BACK_SEAT_PAYMENT]: '汎用QR',
    BACK_SEAT_PAYMENT:                             '汎用QR',
    /**
     * 数値キー: PaymentMethodEnum.APP_PAYMENT_CAB_CARD
     * 名前キー:  APP_PAYMENT_CAB_CARD
     */
    [PaymentMethodEnum.APP_PAYMENT_CAB_CARD]: 'CABPay',
    APP_PAYMENT_CAB_CARD:                             'CABPay',
    /**
     * 数値キー: PaymentMethodEnum.APP_PAYMENT_S_RIDE_BIZ
     * 名前キー:  APP_PAYMENT_S_RIDE_BIZ
     */
    [PaymentMethodEnum.APP_PAYMENT_S_RIDE_BIZ]: '売掛払い',
    APP_PAYMENT_S_RIDE_BIZ:                             '売掛払い',
    /**
     * 数値キー: PaymentMethodEnum.APP_PAY_PAY
     * 名前キー:  APP_PAY_PAY
     */
    [PaymentMethodEnum.APP_PAY_PAY]: 'PayPay',
    APP_PAY_PAY:                             'PayPay',
    /**
     * 数値キー: PaymentMethodEnum.APP_AU_PAY
     * 名前キー:  APP_AU_PAY
     */
    [PaymentMethodEnum.APP_AU_PAY]: 'auPay',
    APP_AU_PAY:                             'auPay',
    /**
     * 数値キー: PaymentMethodEnum.APP_D_PAY
     * 名前キー:  APP_D_PAY
     */
    [PaymentMethodEnum.APP_D_PAY]: 'd払い',
    APP_D_PAY:                             'd払い',
    /**
     * 数値キー: PaymentMethodEnum.APP_R_PAY
     * 名前キー:  APP_R_PAY
     */
    [PaymentMethodEnum.APP_R_PAY]: '楽天Pay',
    APP_R_PAY:                             '楽天Pay',
    /**
     * 数値キー: PaymentMethodEnum.DIDI
     * 名前キー:  DIDI
     */
    [PaymentMethodEnum.DIDI]: 'アプリ決済（DiDi）',
    DIDI:                             'アプリ決済（DiDi）',
    /**
     * 数値キー: PaymentMethodEnum.UBER
     * 名前キー:  UBER
     */
    [PaymentMethodEnum.UBER]: 'アプリ決済（Uber）',
    UBER:                             'アプリ決済（Uber）',
} as const;

/**
 * キャンセル料支払方法 のラベル Union 型
 * @export
 * @typedef PaymentMethodLabel
 */
export type PaymentMethodLabel =
  typeof PaymentMethodLabels[keyof typeof PaymentMethodLabels];

/**
 * キャンセル料支払方法 のラベル取得関数
 * @export
 * @param { PaymentMethod } value - 列挙体の値
 * @returns { PaymentMethodLabel } ラベル文字列
 */
export function getPaymentMethodLabel(
  value: PaymentMethod
): PaymentMethodLabel {
  return PaymentMethodLabels[value];
}

/**
 * キャンセル料支払方法 のラベル配列を取得する関数
 * @export
 * @param { PaymentMethod[] } values - 列挙体の値配列
 * @returns { PaymentMethodLabel[] } ラベル文字列配列
 */
export function getPaymentMethodLabels(values: PaymentMethod[]): PaymentMethodLabel[] {
  return values.map((value) => getPaymentMethodLabel(value));
}

/**
 * キャンセル料支払方法 のラベル配列
 * @export
 */
export const PaymentMethodLabelList = [
  '車内決済','ネット決済','どちらでもよい','ApplePay','RingoPass','汎用QR','CABPay','売掛払い','PayPay','auPay','d払い','楽天Pay','アプリ決済（DiDi）','アプリ決済（Uber）',
] as const;

